import axios from 'axios';
import { ApiLink } from '../APILink/ApiLink';
import { errorAlert } from '../Components/Alerts';

const getRole = async (headers) => {
    try {
        const response = await axios.get(ApiLink.API_URL + 'AuthProva/getrole', { headers });
        // console.log(response.data.UserRole);

        return response.data.UserRole || null; // Kthe rolin ose null nëse nuk ka

        console.log(response.data.UserRole || null);
        
    } catch (error) {
        errorAlert("Error fetching role:");
        return null; // Kthe null në rast gabimi
    }
};

export default getRole;
